import { render, staticRenderFns } from "./Notarization.vue?vue&type=template&id=c401e574&scoped=true&"
import script from "./Notarization.vue?vue&type=script&lang=js&"
export * from "./Notarization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c401e574",
  null
  
)

export default component.exports